export const colors = {
  // 31 shades of grey
  fadeToBlack: '#313131',
  darkText: '#3f5062',
  mrGray: '#666',
  mildGrey: '#8C96A0',
  lightText: '#84909e',
  lanaDelGrey: '#979797',
  iThoughtWeHadAllTheGreys: '#9BA9B4',
  greyLock: '#9da6b1',
  theOtherGray: '#9da9b5',
  theGreyAlbum: '#b3b3b3',
  greyWorm: '#c4c4c4',
  grayvy: '#d0dae1',
  dorianGrey: '#dcdcdc',
  borderLine: '#e6e9eb',
  greyHounds: '#e7e7e7',
  justAnotherGray: '#e8e8e8',
  granite: '#e8e9ea',
  grayArea: '#eaeae8',
  emptyBarGrey: '#ebecee',
  ivory: '#edeff2',
  karl: '#edf4f9',
  diabolicalGrey: '#eef2f5',
  fatherJohnMisty: '#f3f3f3',
  fiveSevenNineGrey: '#f5f7f9',
  greyHairs: '#f6f7f8',
  grayDim: '#f9f9f9',
  whiteGrey: '#fcfcfc',
  pearl: '#fefefc',
  theWhiteAlbum: '#fff',

  ladyInRed: '#ff234e',
  cherryPie: '#f0006a',
  cherryBlossom: '#c31f5c',
  crunchBerry: '#ff0e88',
  pinkElephant: '#ffaebe',
  whitePink: '#fff8fa',
  pinkie: '#ffcbe5',
  pinkish: '#f5ecff',

  pumpkinStew: '#ff5252',
  burntOrange: '#f57123',
  peaches: '#f5a623',
  appStoreSwagger: '#f9c454',
  slightlyYellow: '#fef9ef',
  lemonade: '#f5ff93',
  canary: '#fff8b8',
  goldenrod: '#c58300',

  grannySmith: '#45c071',
  greenHope: '#65cc01',
  greenPeas: '#4D9C01',
  grass: '#7bb342',

  deepSea: '#1a237e',
  blueLoadingScreen: '#516072',
  blueMonday: '#5b6b7d',
  blueish: '#809db2',
  blite: '#d2e9f6',
  blueCloud: '#aec4d4',
  cyanogenBlue: '#dae2e8',
  cyancatBlue: '#aab7c1',
  bahamasBlue: '#00669d',
  tangledUpInBlue: '#0084cc',
  blueJayWay: '#169ae1',
  mrBlueSky: '#40b6f5',
  seaBreeze: '#369ad0',
  shaquilleOteal: '#26a69a',
  aKnightsTeal: '#0097a7',
  comeSailAway: '#10d1b2',
  youGottaRide: '#5ec2ca',
  youGottaRideBack: '#f3fbfc',

  myRightFoot: '#384656',
  squid: '#414f60',
  octopus: '#49496e',
  licorice: '#4c587a',

  bloop: '#f0a6ff',
  purpleHaze: '#af5ebf',
  slightlyPurple: '#fef8fc',
  purpleRain: '#682e9a',
  bruisePurple: '#693673',
  purpSizzurp: '#bb68fd',
  eggplant: '#9c27b0',
  plum: '#673ab7',

  white: '#fff', // theWhiteAlbum
  black: '#313131', // theBlackAlbum
  link: '#0084cc', // tangledUpInBlue

  /** Insurance brand color section */
  aetnaPurple: '#754098',
  ambetterPink: '#ca237d',
  amerigroupBlue: '#0096d4',
  anthemBlue: '#1c79bf',
  bcbsBlue: '#008ccd',
  cignaGreen: '#52b94a',
  humanaGreen: '#5b991c',
  superiorBlue: '#29c4f4',
  uhcBlue: '#173b87',
  /** (end insurance brand color section) */
};
